<table>
    <thead>
        <tr>
            <th class="subtable string">{{'mantenimientoConfecciones.tabs.envases.table.denominacion' | translate}}</th>
            <th class="subtable string">{{'mantenimientoConfecciones.tabs.envases.table.envase' | translate}}</th>
            <th class="subtable number">{{'mantenimientoConfecciones.tabs.envases.table.numEnvasesCaja' | translate}}</th>
            <th class="subtable number">{{'mantenimientoConfecciones.tabs.envases.table.peso' | translate}}</th>
            <th class="subtable action"></th>
        </tr>
    </thead>
    <tbody *ngFor="let cajaEnvasePorcion of cajasConfeccion; let i = index">
        <tr>
            <td class="string">{{cajaEnvasePorcion.desDenominacion}}</td>
            <td class="string">{{cajaEnvasePorcion.desEnvase}}</td>
            <td class="number">{{cajaEnvasePorcion.numElemAgrupados}}</td>
            <td class="number">{{cajaEnvasePorcion.sumKilos | number : '1.2-2': defaultLanguage}}</td>
            <td class="multi-actions">
                <i *ngIf="cajaEnvasePorcion.cantidadPorcionesEnvase > 1" class="fas fa-stream" app-click-stop-propagation (click)="showSection(i)"
                    title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
            </td>
        </tr>
        <tr *ngIf="dropdownSection === i">
            <td colspan="2">
              <section class="tabs">
                <ul>
                  <li>{{'mantenimientoConfecciones.tabs.envases.table.tabs.porcion.des' | translate}}</li>
                </ul>
                <content>
                    <app-porciones-envase [porcionesEnvase]="cajaEnvasePorcion.porciones"></app-porciones-envase>
                </content>
              </section>
            </td>
        </tr>
    </tbody>
    <tfoot *ngIf="!cajasConfeccion || (cajasConfeccion && cajasConfeccion.length < 1)">
        <tr>
          <td colspan="9">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>